import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Ajustview } from './components/ajustview';



const AjustesPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Ajustes',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Ajustes</PageTitle>
      <Ajustview/>
    </>
  );
};

export {AjustesPage}